import SafeBaseClient from './SafeBaseClient';

export default class FullStoryClient extends SafeBaseClient {
  constructor(config) {
    super('fullstory', config);
  }

  trackUser = async (eventName, eventData = {}, log, noPublish) => {
    const {
      userId,
      purchaseId,
      stockNumber,
      email,
      name,
      experiments
    } = eventData;
    const fullStoryUserAttributes = {
      isProjectPhoenixPurchase_bool: true,
      purchaseId_str: purchaseId?.toString(),
      stockNumber_str: stockNumber?.toString(),
      userId_str: userId,
      email,
      displayName: name,
      experiments_strs: experiments
    };

    if (window.FS) {
      if (log) {
        log('[Analytics_FullStory_User]', {
          eventName,
          fullStoryUserAttributes
        });
      }

      if (!noPublish) {
        window.FS.setUserVars(fullStoryUserAttributes);
      }
    }
  };
}
